import React from 'react';
import { GearAssetsHeaderMain, OnboardGearSection, OnboardGearTitle, OnboardGearBody, OnboardGearFooter, OnboardGearBtn } from './styles';
import { GearTypes } from 'Config/gearAssetsConstant';

const GearAssetsHeader = ({
  onChangeRightNav,
  gears,
}) => {

    const handleBtnClick = (rightNavTitle) => {
        onChangeRightNav(rightNavTitle);
    };

    return (
        <GearAssetsHeaderMain>
            {Object.entries(GearTypes).map(([key, info]) => {
                return (
                    <OnboardGearSection key={key}>
                        <OnboardGearTitle>
                            {info?.fullname}
                        </OnboardGearTitle>
                        <OnboardGearBody>
                            Total Onboarded {info?.name}s: {gears?.[info.stateKey]?.length || 0}
                        </OnboardGearBody>
                        <OnboardGearFooter>
                            <OnboardGearBtn onClick={() => handleBtnClick(info?.rightNavTitle)}>
                                + Onboard {info?.name}
                            </OnboardGearBtn>
                        </OnboardGearFooter>
                    </OnboardGearSection>
                )
            })}
        </GearAssetsHeaderMain>
    );
};

export default GearAssetsHeader;
